import { render, staticRenderFns } from "./Slack-Tag-Selector.vue?vue&type=template&id=681d8958&lang=pug"
import script from "./Slack-Tag-Selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./Slack-Tag-Selector.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports